/** Currency resolution — mirrors backend/currency_utils.py for display. */

const CAD_CITY_HINTS = /\b(toronto|vancouver|montreal|montréal|calgary|edmonton|ottawa|winnipeg|mississauga|brampton|hamilton|kitchener|waterloo|victoria|halifax|quebec|saskatoon|regina|london|markham|surrey|burnaby|langley|richmond|canada|on\b|bc\b|ab\b|qc\b)\b/i;
const USD_CITY_HINTS = /\b(new york|nyc|los angeles|la|san francisco|sf|chicago|miami|austin|boston|seattle|portland|denver|atlanta|dallas|houston|orlando|united states|usa)\b/i;

export function resolveCurrency({ city = "", country = "", currency = null } = {}) {
  if (currency) return String(currency).toUpperCase();
  const c = (country || "").trim().toUpperCase();
  if (c === "US" || c === "USA" || c === "UNITED STATES") return "USD";
  if (c === "CA" || c === "CAN" || c === "CANADA") return "CAD";
  const loc = `${city} ${country}`.trim();
  if (loc && CAD_CITY_HINTS.test(loc)) return "CAD";
  if (loc && USD_CITY_HINTS.test(loc)) return "USD";
  return "USD";
}

export function vehicleCurrency(vehicle) {
  if (!vehicle) return "USD";
  const city = [vehicle.location_city, vehicle.location_address].filter(Boolean).join(" ").trim();
  return resolveCurrency({
    city,
    country: vehicle.country || "",
    currency: vehicle.currency || null,
  });
}

/** Server suggestion currency wins; location resolution keeps pre-request UI accurate. */
export function priceSuggestionCurrency(suggestion, { city = "", country = "" } = {}) {
  return resolveCurrency({
    city,
    country,
    currency: suggestion?.currency || null,
  });
}

/** Plain USD number for inline `$${formatUsd(n)}` patterns. */
export function formatUsd(amount) {
  const n = Number(amount);
  return Number.isFinite(n) ? n.toFixed(2) : "0.00";
}

/** Safe fixed-decimal formatter for any numeric field (ratings, counts-as-money, etc.). */
export function formatNumber(amount, decimals = 2) {
  const n = Number(amount);
  return Number.isFinite(n) ? n.toFixed(decimals) : (0).toFixed(decimals);
}

export function formatMoney(amount, currency = "USD") {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "";
  const code = (currency || "USD").toUpperCase();
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return `$${n.toFixed(2)}`;
  }
}
